"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorWhitelisted = void 0;
const resource_model_1 = require("./resource.model");
/**
 * A whitelisted error for a project, i.e. an error to ignore during the reporting for a specific project.
 *
 * Table: `idea_projects_errorsWhitelisted`.
 */
class ErrorWhitelisted extends resource_model_1.Resource {
    load(x) {
        super.load(x);
        this.project = this.clean(x.project, String);
        this.error = this.clean(x.error, String);
        this.createdAt = this.clean(x.createdAt, t => new Date(t).toISOString());
        this.notes = this.clean(x.notes, String);
    }
}
exports.ErrorWhitelisted = ErrorWhitelisted;
